// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralFillToggleHover, neutralForegroundHint, neutralLayerCard } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { reset } from "../../utils/commonJssConstants";

export const UGContentListStyles = (config: DesignSystem) => ({
    ugContentListContainer: {
        ...reset,
        width: "768px",
        "max-width": "calc(100% - 40px)",
        padding: "40px 20px",
        background: neutralLayerCard,
        "border-radius": "8px",

        "& .cwt-buttons": {
            [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "auto",
            display: "flex",
            padding: "7px 0",
            "flex-wrap": "wrap",

            "& .cwt-fast-button": {
                [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "9px"
            }
        },

        "& .cwt-ug-content-list": {
            padding: "0"
        },

        "& .cwt-content-info": {
            display: "flex",
            "align-items": "center",
            margin: "16px 0",
            padding: "12px",
            border: "1px solid #DDDDDD",
            "border-radius": "8px",

            "& .cwt-content-image": {
                margin: "0",
                "object-fit": "cover",
                width: "68px",
                height: "45px",
                border: "none",
                "border-radius": "4px"
            },

            "& .cwt-ug-content-details": {
                display: "flex",
                "flex-direction": "column",
                [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "14px",
                color: neutralFillToggleHover,

                "& .cwt-content-title": {
                    "font-size": "14px",
                    "font-weight": "600",
                    color: neutralFillToggleHover
                },

                "& .cwt-datetime": {
                    "font-size": "12px",
                    color: neutralForegroundHint
                }
            }
        }
    }
});